module.exports = __webpack_public_path__ + "static/media/img-culture.436891bd.svg";